import React from 'react';
import { BillingAccountWidgetItem } from '../../../../recently-viewed/src/template/src/billing-account-widget-items';
import { FavouritedData } from '@atlassian/cssxp-typescommon';

type BillingAccounts = FavouritedData[];

export const getFavouritedBillingAccountWidgetContent = (billingAccounts: BillingAccounts) => {
  if (!billingAccounts || !billingAccounts.length) {
    return <div style={{ marginTop: '15px' }}>No Billing accounts marked as favorites yet</div>;
  }

  return billingAccounts.map((billingAccount, index) => {
    return <BillingAccountWidgetItem key={index} {...billingAccount} />;
  });
};
